{
    "defaults": {
        "CoastalStates": [],
        "StateCoastal": [],
        "CoastalWatershedStates": [],
        "ENOW": [
            "oceanEconomy",
            "selfEmployment"
        ],
        "OpenENOW": [],
        "ShorelineCounties": [
            "communitySurvey",
            "coastalEconomy",
            "demographics"
        ],
        "WatershedCounties": [
            "communitySurvey",
            "coastalEconomy",
            "demographics"
        ]
    },
    "counties": [
        {
            "id": "01003",
            "label": "Baldwin County",
            "stateId": "01000",
            "state": "AL"
        },
        {
            "id": "01025",
            "label": "Clarke County",
            "stateId": "01000",
            "state": "AL",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "01039",
            "label": "Covington County",
            "stateId": "01000",
            "state": "AL",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "01053",
            "label": "Escambia County",
            "stateId": "01000",
            "state": "AL",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "01061",
            "label": "Geneva County",
            "stateId": "01000",
            "state": "AL",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "01097",
            "label": "Mobile County",
            "stateId": "01000",
            "state": "AL"
        },
        {
            "id": "01099",
            "label": "Monroe County",
            "stateId": "01000",
            "state": "AL",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "01129",
            "label": "Washington County",
            "stateId": "01000",
            "state": "AL",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "02013",
            "label": "Aleutians East Borough",
            "stateId": "02000",
            "state": "AK"
        },
        {
            "id": "02016",
            "label": "Aleutians West Census Area",
            "stateId": "02000",
            "state": "AK"
        },
        {
            "id": "02020",
            "label": "Anchorage Municipality",
            "stateId": "02000",
            "state": "AK"
        },
        {
            "id": "02050",
            "label": "Bethel Census Area",
            "stateId": "02000",
            "state": "AK"
        },
        {
            "id": "02060",
            "label": "Bristol Bay Borough",
            "stateId": "02000",
            "state": "AK"
        },
        {
            "id": "02070",
            "label": "Dillingham Census Area",
            "stateId": "02000",
            "state": "AK"
        },
        {
            "id": "02100",
            "label": "Haines Borough",
            "stateId": "02000",
            "state": "AK"
        },
        {
            "id": "02105",
            "label": "Hoonah-Angoon Census Area",
            "stateId": "02000",
            "state": "AK"
        },
        {
            "id": "02110",
            "label": "Juneau City and Borough",
            "stateId": "02000",
            "state": "AK"
        },
        {
            "id": "02122",
            "label": "Kenai Peninsula Borough",
            "stateId": "02000",
            "state": "AK"
        },
        {
            "id": "02130",
            "label": "Ketchikan Gateway Borough",
            "stateId": "02000",
            "state": "AK"
        },
        {
            "id": "02150",
            "label": "Kodiak Island Borough",
            "stateId": "02000",
            "state": "AK"
        },
        {
            "id": "02164",
            "label": "Lake and Peninsula Borough",
            "stateId": "02000",
            "state": "AK"
        },
        {
            "id": "02170",
            "label": "Matanuska-Susitna Borough",
            "stateId": "02000",
            "state": "AK"
        },
        {
            "id": "02180",
            "label": "Nome Census Area",
            "stateId": "02000",
            "state": "AK"
        },
        {
            "id": "02185",
            "label": "North Slope Borough",
            "stateId": "02000",
            "state": "AK"
        },
        {
            "id": "02188",
            "label": "Northwest Arctic Borough",
            "stateId": "02000",
            "state": "AK"
        },
        {
            "id": "02195",
            "label": "Petersburg Census Area",
            "stateId": "02000",
            "state": "AK"
        },
        {
            "id": "02198",
            "label": "Prince of Wales-Hyder Census Area",
            "stateId": "02000",
            "state": "AK"
        },
        {
            "id": "02201",
            "label": "Prince of Wales-Outer Ketchika",
            "stateId": "02000",
            "state": "AK",
            "ShorelineCounties": [],
            "WatershedCounties": []
        },
        {
            "id": "02220",
            "label": "Sitka City and Borough",
            "stateId": "02000",
            "state": "AK"
        },
        {
            "id": "02230",
            "label": "Skagway Municipality",
            "stateId": "02000",
            "state": "AK",
            "ENOW": []
        },
        {
            "id": "02232",
            "label": "Skagway-Hoonah-Angoon",
            "stateId": "02000",
            "state": "AK",
            "ShorelineCounties": [],
            "WatershedCounties": []
        },
        {
            "id": "02261",
            "label": "Valdez-Cordova Census Area",
            "stateId": "02000",
            "state": "AK"
        },
        {
            "id": "02270",
            "label": "Wade Hampton Census Area",
            "stateId": "02000",
            "state": "AK"
        },
        {
            "id": "02275",
            "label": "Wrangell City and Borough",
            "stateId": "02000",
            "state": "AK"
        },
        {
            "id": "02280",
            "label": "Wrangell-Petersburg",
            "stateId": "02000",
            "state": "AK",
            "ShorelineCounties": [],
            "WatershedCounties": []
        },
        {
            "id": "02282",
            "label": "Yakutat City and Borough",
            "stateId": "02000",
            "state": "AK"
        },
        {
            "id": "06001",
            "label": "Alameda County",
            "stateId": "06000",
            "state": "CA"
        },
        {
            "id": "06013",
            "label": "Contra Costa County",
            "stateId": "06000",
            "state": "CA"
        },
        {
            "id": "06015",
            "label": "Del Norte County",
            "stateId": "06000",
            "state": "CA"
        },
        {
            "id": "06023",
            "label": "Humboldt County",
            "stateId": "06000",
            "state": "CA"
        },
        {
            "id": "06037",
            "label": "Los Angeles County",
            "stateId": "06000",
            "state": "CA"
        },
        {
            "id": "06041",
            "label": "Marin County",
            "stateId": "06000",
            "state": "CA"
        },
        {
            "id": "06045",
            "label": "Mendocino County",
            "stateId": "06000",
            "state": "CA"
        },
        {
            "id": "06053",
            "label": "Monterey County",
            "stateId": "06000",
            "state": "CA"
        },
        {
            "id": "06055",
            "label": "Napa County",
            "stateId": "06000",
            "state": "CA"
        },
        {
            "id": "06059",
            "label": "Orange County",
            "stateId": "06000",
            "state": "CA"
        },
        {
            "id": "06065",
            "label": "Riverside County",
            "stateId": "06000",
            "state": "CA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "06067",
            "label": "Sacramento County",
            "stateId": "06000",
            "state": "CA",
            "ShorelineCounties": []
        },
        {
            "id": "06069",
            "label": "San Benito County",
            "stateId": "06000",
            "state": "CA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "06071",
            "label": "San Bernardino County",
            "stateId": "06000",
            "state": "CA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "06073",
            "label": "San Diego County",
            "stateId": "06000",
            "state": "CA"
        },
        {
            "id": "06075",
            "label": "San Francisco County",
            "stateId": "06000",
            "state": "CA"
        },
        {
            "id": "06077",
            "label": "San Joaquin County",
            "stateId": "06000",
            "state": "CA",
            "ShorelineCounties": []
        },
        {
            "id": "06079",
            "label": "San Luis Obispo County",
            "stateId": "06000",
            "state": "CA"
        },
        {
            "id": "06081",
            "label": "San Mateo County",
            "stateId": "06000",
            "state": "CA"
        },
        {
            "id": "06083",
            "label": "Santa Barbara County",
            "stateId": "06000",
            "state": "CA"
        },
        {
            "id": "06085",
            "label": "Santa Clara County",
            "stateId": "06000",
            "state": "CA"
        },
        {
            "id": "06087",
            "label": "Santa Cruz County",
            "stateId": "06000",
            "state": "CA"
        },
        {
            "id": "06093",
            "label": "Siskiyou County",
            "stateId": "06000",
            "state": "CA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "06095",
            "label": "Solano County",
            "stateId": "06000",
            "state": "CA"
        },
        {
            "id": "06097",
            "label": "Sonoma County",
            "stateId": "06000",
            "state": "CA"
        },
        {
            "id": "06101",
            "label": "Sutter County",
            "stateId": "06000",
            "state": "CA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "06105",
            "label": "Trinity County",
            "stateId": "06000",
            "state": "CA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "06111",
            "label": "Ventura County",
            "stateId": "06000",
            "state": "CA"
        },
        {
            "id": "06113",
            "label": "Yolo County",
            "stateId": "06000",
            "state": "CA",
            "ShorelineCounties": []
        },
        {
            "id": "09001",
            "label": "Fairfield County",
            "stateId": "09000",
            "state": "CT"
        },
        {
            "id": "09003",
            "label": "Hartford County",
            "stateId": "09000",
            "state": "CT",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "09005",
            "label": "Litchfield County",
            "stateId": "09000",
            "state": "CT",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "09007",
            "label": "Middlesex County",
            "stateId": "09000",
            "state": "CT"
        },
        {
            "id": "09009",
            "label": "New Haven County",
            "stateId": "09000",
            "state": "CT"
        },
        {
            "id": "09011",
            "label": "New London County",
            "stateId": "09000",
            "state": "CT"
        },
        {
            "id": "09013",
            "label": "Tolland County",
            "stateId": "09000",
            "state": "CT",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "09015",
            "label": "Windham County",
            "stateId": "09000",
            "state": "CT",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "10001",
            "label": "Kent County",
            "stateId": "10000",
            "state": "DE"
        },
        {
            "id": "10003",
            "label": "New Castle County",
            "stateId": "10000",
            "state": "DE"
        },
        {
            "id": "10005",
            "label": "Sussex County",
            "stateId": "10000",
            "state": "DE"
        },
        {
            "id": "11001",
            "label": "District of Columbia",
            "stateId": "11000",
            "state": "DC",
            "ENOW": []
        },
        {
            "id": "12003",
            "label": "Baker County",
            "stateId": "12000",
            "state": "FL",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "12005",
            "label": "Bay County",
            "stateId": "12000",
            "state": "FL"
        },
        {
            "id": "12009",
            "label": "Brevard County",
            "stateId": "12000",
            "state": "FL"
        },
        {
            "id": "12011",
            "label": "Broward County",
            "stateId": "12000",
            "state": "FL"
        },
        {
            "id": "12013",
            "label": "Calhoun County",
            "stateId": "12000",
            "state": "FL",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "12015",
            "label": "Charlotte County",
            "stateId": "12000",
            "state": "FL"
        },
        {
            "id": "12017",
            "label": "Citrus County",
            "stateId": "12000",
            "state": "FL"
        },
        {
            "id": "12019",
            "label": "Clay County",
            "stateId": "12000",
            "state": "FL"
        },
        {
            "id": "12021",
            "label": "Collier County",
            "stateId": "12000",
            "state": "FL"
        },
        {
            "id": "12027",
            "label": "DeSoto County",
            "stateId": "12000",
            "state": "FL",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "12029",
            "label": "Dixie County",
            "stateId": "12000",
            "state": "FL"
        },
        {
            "id": "12031",
            "label": "Duval County",
            "stateId": "12000",
            "state": "FL"
        },
        {
            "id": "12033",
            "label": "Escambia County",
            "stateId": "12000",
            "state": "FL"
        },
        {
            "id": "12035",
            "label": "Flagler County",
            "stateId": "12000",
            "state": "FL"
        },
        {
            "id": "12037",
            "label": "Franklin County",
            "stateId": "12000",
            "state": "FL"
        },
        {
            "id": "12039",
            "label": "Gadsden County",
            "stateId": "12000",
            "state": "FL",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "12041",
            "label": "Gilchrist County",
            "stateId": "12000",
            "state": "FL",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "12043",
            "label": "Glades County",
            "stateId": "12000",
            "state": "FL",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "12045",
            "label": "Gulf County",
            "stateId": "12000",
            "state": "FL"
        },
        {
            "id": "12049",
            "label": "Hardee County",
            "stateId": "12000",
            "state": "FL",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "12051",
            "label": "Hendry County",
            "stateId": "12000",
            "state": "FL",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "12053",
            "label": "Hernando County",
            "stateId": "12000",
            "state": "FL"
        },
        {
            "id": "12055",
            "label": "Highlands County",
            "stateId": "12000",
            "state": "FL",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "12057",
            "label": "Hillsborough County",
            "stateId": "12000",
            "state": "FL"
        },
        {
            "id": "12059",
            "label": "Holmes County",
            "stateId": "12000",
            "state": "FL",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "12061",
            "label": "Indian River County",
            "stateId": "12000",
            "state": "FL"
        },
        {
            "id": "12063",
            "label": "Jackson County",
            "stateId": "12000",
            "state": "FL",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "12065",
            "label": "Jefferson County",
            "stateId": "12000",
            "state": "FL"
        },
        {
            "id": "12067",
            "label": "Lafayette County",
            "stateId": "12000",
            "state": "FL",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "12069",
            "label": "Lake County",
            "stateId": "12000",
            "state": "FL",
            "ShorelineCounties": []
        },
        {
            "id": "12071",
            "label": "Lee County",
            "stateId": "12000",
            "state": "FL"
        },
        {
            "id": "12073",
            "label": "Leon County",
            "stateId": "12000",
            "state": "FL",
            "ShorelineCounties": []
        },
        {
            "id": "12075",
            "label": "Levy County",
            "stateId": "12000",
            "state": "FL"
        },
        {
            "id": "12077",
            "label": "Liberty County",
            "stateId": "12000",
            "state": "FL"
        },
        {
            "id": "12079",
            "label": "Madison County",
            "stateId": "12000",
            "state": "FL",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "12081",
            "label": "Manatee County",
            "stateId": "12000",
            "state": "FL"
        },
        {
            "id": "12083",
            "label": "Marion County",
            "stateId": "12000",
            "state": "FL",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "12085",
            "label": "Martin County",
            "stateId": "12000",
            "state": "FL"
        },
        {
            "id": "12086",
            "label": "Miami-Dade County",
            "stateId": "12000",
            "state": "FL"
        },
        {
            "id": "12087",
            "label": "Monroe County",
            "stateId": "12000",
            "state": "FL"
        },
        {
            "id": "12089",
            "label": "Nassau County",
            "stateId": "12000",
            "state": "FL"
        },
        {
            "id": "12091",
            "label": "Okaloosa County",
            "stateId": "12000",
            "state": "FL"
        },
        {
            "id": "12093",
            "label": "Okeechobee County",
            "stateId": "12000",
            "state": "FL",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "12095",
            "label": "Orange County",
            "stateId": "12000",
            "state": "FL",
            "ShorelineCounties": []
        },
        {
            "id": "12097",
            "label": "Osceola County",
            "stateId": "12000",
            "state": "FL",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "12099",
            "label": "Palm Beach County",
            "stateId": "12000",
            "state": "FL"
        },
        {
            "id": "12101",
            "label": "Pasco County",
            "stateId": "12000",
            "state": "FL"
        },
        {
            "id": "12103",
            "label": "Pinellas County",
            "stateId": "12000",
            "state": "FL"
        },
        {
            "id": "12105",
            "label": "Polk County",
            "stateId": "12000",
            "state": "FL",
            "ShorelineCounties": []
        },
        {
            "id": "12107",
            "label": "Putnam County",
            "stateId": "12000",
            "state": "FL"
        },
        {
            "id": "12113",
            "label": "Santa Rosa County",
            "stateId": "12000",
            "state": "FL"
        },
        {
            "id": "12115",
            "label": "Sarasota County",
            "stateId": "12000",
            "state": "FL"
        },
        {
            "id": "12117",
            "label": "Seminole County",
            "stateId": "12000",
            "state": "FL",
            "ShorelineCounties": []
        },
        {
            "id": "12109",
            "label": "St. Johns County",
            "stateId": "12000",
            "state": "FL"
        },
        {
            "id": "12111",
            "label": "St. Lucie County",
            "stateId": "12000",
            "state": "FL"
        },
        {
            "id": "12119",
            "label": "Sumter County",
            "stateId": "12000",
            "state": "FL",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "12121",
            "label": "Suwannee County",
            "stateId": "12000",
            "state": "FL",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "12123",
            "label": "Taylor County",
            "stateId": "12000",
            "state": "FL"
        },
        {
            "id": "12127",
            "label": "Volusia County",
            "stateId": "12000",
            "state": "FL"
        },
        {
            "id": "12129",
            "label": "Wakulla County",
            "stateId": "12000",
            "state": "FL"
        },
        {
            "id": "12131",
            "label": "Walton County",
            "stateId": "12000",
            "state": "FL"
        },
        {
            "id": "12133",
            "label": "Washington County",
            "stateId": "12000",
            "state": "FL",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "13001",
            "label": "Appling County",
            "stateId": "13000",
            "state": "GA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "13003",
            "label": "Atkinson County",
            "stateId": "13000",
            "state": "GA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "13005",
            "label": "Bacon County",
            "stateId": "13000",
            "state": "GA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "13025",
            "label": "Brantley County",
            "stateId": "13000",
            "state": "GA"
        },
        {
            "id": "13029",
            "label": "Bryan County",
            "stateId": "13000",
            "state": "GA"
        },
        {
            "id": "13031",
            "label": "Bulloch County",
            "stateId": "13000",
            "state": "GA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "13039",
            "label": "Camden County",
            "stateId": "13000",
            "state": "GA"
        },
        {
            "id": "13049",
            "label": "Charlton County",
            "stateId": "13000",
            "state": "GA"
        },
        {
            "id": "13051",
            "label": "Chatham County",
            "stateId": "13000",
            "state": "GA"
        },
        {
            "id": "13069",
            "label": "Coffee County",
            "stateId": "13000",
            "state": "GA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "13087",
            "label": "Decatur County",
            "stateId": "13000",
            "state": "GA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "13103",
            "label": "Effingham County",
            "stateId": "13000",
            "state": "GA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "13127",
            "label": "Glynn County",
            "stateId": "13000",
            "state": "GA"
        },
        {
            "id": "13131",
            "label": "Grady County",
            "stateId": "13000",
            "state": "GA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "13155",
            "label": "Irwin County",
            "stateId": "13000",
            "state": "GA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "13161",
            "label": "Jeff Davis County",
            "stateId": "13000",
            "state": "GA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "13165",
            "label": "Jenkins County",
            "stateId": "13000",
            "state": "GA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "13179",
            "label": "Liberty County",
            "stateId": "13000",
            "state": "GA"
        },
        {
            "id": "13183",
            "label": "Long County",
            "stateId": "13000",
            "state": "GA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "13191",
            "label": "McIntosh County",
            "stateId": "13000",
            "state": "GA"
        },
        {
            "id": "13209",
            "label": "Montgomery County",
            "stateId": "13000",
            "state": "GA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "13229",
            "label": "Pierce County",
            "stateId": "13000",
            "state": "GA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "13251",
            "label": "Screven County",
            "stateId": "13000",
            "state": "GA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "13267",
            "label": "Tattnall County",
            "stateId": "13000",
            "state": "GA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "13275",
            "label": "Thomas County",
            "stateId": "13000",
            "state": "GA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "13279",
            "label": "Toombs County",
            "stateId": "13000",
            "state": "GA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "13299",
            "label": "Ware County",
            "stateId": "13000",
            "state": "GA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "13305",
            "label": "Wayne County",
            "stateId": "13000",
            "state": "GA"
        },
        {
            "id": "15001",
            "label": "Hawaii County",
            "stateId": "15000",
            "state": "HI"
        },
        {
            "id": "15003",
            "label": "Honolulu County",
            "stateId": "15000",
            "state": "HI"
        },
        {
            "id": "15005",
            "label": "Kalawao County",
            "stateId": "15000",
            "state": "HI"
        },
        {
            "id": "15007",
            "label": "Kauai County",
            "stateId": "15000",
            "state": "HI"
        },
        {
            "id": "15009",
            "label": "Maui County",
            "stateId": "15000",
            "state": "HI"
        },
        {
            "id": "17031",
            "label": "Cook County",
            "stateId": "17000",
            "state": "IL"
        },
        {
            "id": "17097",
            "label": "Lake County",
            "stateId": "17000",
            "state": "IL"
        },
        {
            "id": "18039",
            "label": "Elkhart County",
            "stateId": "18000",
            "state": "IN",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "18085",
            "label": "Kosciusko County",
            "stateId": "18000",
            "state": "IN",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "18087",
            "label": "LaGrange County",
            "stateId": "18000",
            "state": "IN",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "18089",
            "label": "Lake County",
            "stateId": "18000",
            "state": "IN"
        },
        {
            "id": "18091",
            "label": "LaPorte County",
            "stateId": "18000",
            "state": "IN"
        },
        {
            "id": "18113",
            "label": "Noble County",
            "stateId": "18000",
            "state": "IN",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "18127",
            "label": "Porter County",
            "stateId": "18000",
            "state": "IN"
        },
        {
            "id": "18141",
            "label": "St. Joseph County",
            "stateId": "18000",
            "state": "IN",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "18151",
            "label": "Steuben County",
            "stateId": "18000",
            "state": "IN",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "22001",
            "label": "Acadia Parish",
            "stateId": "22000",
            "state": "LA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "22003",
            "label": "Allen Parish",
            "stateId": "22000",
            "state": "LA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "22005",
            "label": "Ascension Parish",
            "stateId": "22000",
            "state": "LA",
            "ENOW": []
        },
        {
            "id": "22007",
            "label": "Assumption Parish",
            "stateId": "22000",
            "state": "LA",
            "ENOW": []
        },
        {
            "id": "22009",
            "label": "Avoyelles Parish",
            "stateId": "22000",
            "state": "LA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "22011",
            "label": "Beauregard Parish",
            "stateId": "22000",
            "state": "LA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "22019",
            "label": "Calcasieu Parish",
            "stateId": "22000",
            "state": "LA"
        },
        {
            "id": "22023",
            "label": "Cameron Parish",
            "stateId": "22000",
            "state": "LA"
        },
        {
            "id": "22033",
            "label": "East Baton Rouge Parish",
            "stateId": "22000",
            "state": "LA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "22037",
            "label": "East Feliciana Parish",
            "stateId": "22000",
            "state": "LA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "22039",
            "label": "Evangeline Parish",
            "stateId": "22000",
            "state": "LA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "22045",
            "label": "Iberia Parish",
            "stateId": "22000",
            "state": "LA"
        },
        {
            "id": "22047",
            "label": "Iberville Parish",
            "stateId": "22000",
            "state": "LA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "22053",
            "label": "Jefferson Davis Parish",
            "stateId": "22000",
            "state": "LA",
            "ENOW": []
        },
        {
            "id": "22051",
            "label": "Jefferson Parish",
            "stateId": "22000",
            "state": "LA"
        },
        {
            "id": "22055",
            "label": "Lafayette Parish",
            "stateId": "22000",
            "state": "LA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "22057",
            "label": "Lafourche Parish",
            "stateId": "22000",
            "state": "LA"
        },
        {
            "id": "22063",
            "label": "Livingston Parish",
            "stateId": "22000",
            "state": "LA"
        },
        {
            "id": "22071",
            "label": "Orleans Parish",
            "stateId": "22000",
            "state": "LA"
        },
        {
            "id": "22075",
            "label": "Plaquemines Parish",
            "stateId": "22000",
            "state": "LA"
        },
        {
            "id": "22077",
            "label": "Pointe Coupee Parish",
            "stateId": "22000",
            "state": "LA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "22079",
            "label": "Rapides Parish",
            "stateId": "22000",
            "state": "LA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "22085",
            "label": "Sabine Parish",
            "stateId": "22000",
            "state": "LA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "22087",
            "label": "St. Bernard Parish",
            "stateId": "22000",
            "state": "LA"
        },
        {
            "id": "22089",
            "label": "St. Charles Parish",
            "stateId": "22000",
            "state": "LA"
        },
        {
            "id": "22091",
            "label": "St. Helena Parish",
            "stateId": "22000",
            "state": "LA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "22093",
            "label": "St. James Parish",
            "stateId": "22000",
            "state": "LA"
        },
        {
            "id": "22095",
            "label": "St. John the Baptist Parish",
            "stateId": "22000",
            "state": "LA"
        },
        {
            "id": "22097",
            "label": "St. Landry Parish",
            "stateId": "22000",
            "state": "LA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "22099",
            "label": "St. Martin Parish",
            "stateId": "22000",
            "state": "LA"
        },
        {
            "id": "22101",
            "label": "St. Mary Parish",
            "stateId": "22000",
            "state": "LA"
        },
        {
            "id": "22103",
            "label": "St. Tammany Parish",
            "stateId": "22000",
            "state": "LA"
        },
        {
            "id": "22105",
            "label": "Tangipahoa Parish",
            "stateId": "22000",
            "state": "LA"
        },
        {
            "id": "22109",
            "label": "Terrebonne Parish",
            "stateId": "22000",
            "state": "LA"
        },
        {
            "id": "22113",
            "label": "Vermilion Parish",
            "stateId": "22000",
            "state": "LA"
        },
        {
            "id": "22115",
            "label": "Vernon Parish",
            "stateId": "22000",
            "state": "LA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "22117",
            "label": "Washington Parish",
            "stateId": "22000",
            "state": "LA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "22121",
            "label": "West Baton Rouge Parish",
            "stateId": "22000",
            "state": "LA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "22125",
            "label": "West Feliciana Parish",
            "stateId": "22000",
            "state": "LA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "23001",
            "label": "Androscoggin County",
            "stateId": "23000",
            "state": "ME",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "23005",
            "label": "Cumberland County",
            "stateId": "23000",
            "state": "ME"
        },
        {
            "id": "23007",
            "label": "Franklin County",
            "stateId": "23000",
            "state": "ME",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "23009",
            "label": "Hancock County",
            "stateId": "23000",
            "state": "ME"
        },
        {
            "id": "23011",
            "label": "Kennebec County",
            "stateId": "23000",
            "state": "ME",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "23013",
            "label": "Knox County",
            "stateId": "23000",
            "state": "ME"
        },
        {
            "id": "23015",
            "label": "Lincoln County",
            "stateId": "23000",
            "state": "ME"
        },
        {
            "id": "23017",
            "label": "Oxford County",
            "stateId": "23000",
            "state": "ME",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "23019",
            "label": "Penobscot County",
            "stateId": "23000",
            "state": "ME",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "23023",
            "label": "Sagadahoc County",
            "stateId": "23000",
            "state": "ME"
        },
        {
            "id": "23025",
            "label": "Somerset County",
            "stateId": "23000",
            "state": "ME",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "23027",
            "label": "Waldo County",
            "stateId": "23000",
            "state": "ME"
        },
        {
            "id": "23029",
            "label": "Washington County",
            "stateId": "23000",
            "state": "ME"
        },
        {
            "id": "23031",
            "label": "York County",
            "stateId": "23000",
            "state": "ME"
        },
        {
            "id": "24003",
            "label": "Anne Arundel County",
            "stateId": "24000",
            "state": "MD"
        },
        {
            "id": "24510",
            "label": "Baltimore City",
            "stateId": "24000",
            "state": "MD"
        },
        {
            "id": "24005",
            "label": "Baltimore County",
            "stateId": "24000",
            "state": "MD"
        },
        {
            "id": "24009",
            "label": "Calvert County",
            "stateId": "24000",
            "state": "MD"
        },
        {
            "id": "24011",
            "label": "Caroline County",
            "stateId": "24000",
            "state": "MD"
        },
        {
            "id": "24013",
            "label": "Carroll County",
            "stateId": "24000",
            "state": "MD",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "24015",
            "label": "Cecil County",
            "stateId": "24000",
            "state": "MD"
        },
        {
            "id": "24017",
            "label": "Charles County",
            "stateId": "24000",
            "state": "MD"
        },
        {
            "id": "24019",
            "label": "Dorchester County",
            "stateId": "24000",
            "state": "MD"
        },
        {
            "id": "24025",
            "label": "Harford County",
            "stateId": "24000",
            "state": "MD"
        },
        {
            "id": "24027",
            "label": "Howard County",
            "stateId": "24000",
            "state": "MD",
            "ENOW": []
        },
        {
            "id": "24029",
            "label": "Kent County",
            "stateId": "24000",
            "state": "MD"
        },
        {
            "id": "24031",
            "label": "Montgomery County",
            "stateId": "24000",
            "state": "MD",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "24033",
            "label": "Prince George's County",
            "stateId": "24000",
            "state": "MD"
        },
        {
            "id": "24035",
            "label": "Queen Anne's County",
            "stateId": "24000",
            "state": "MD"
        },
        {
            "id": "24039",
            "label": "Somerset County",
            "stateId": "24000",
            "state": "MD"
        },
        {
            "id": "24037",
            "label": "St. Mary's County",
            "stateId": "24000",
            "state": "MD"
        },
        {
            "id": "24041",
            "label": "Talbot County",
            "stateId": "24000",
            "state": "MD"
        },
        {
            "id": "24045",
            "label": "Wicomico County",
            "stateId": "24000",
            "state": "MD"
        },
        {
            "id": "24047",
            "label": "Worcester County",
            "stateId": "24000",
            "state": "MD"
        },
        {
            "id": "25001",
            "label": "Barnstable County",
            "stateId": "25000",
            "state": "MA"
        },
        {
            "id": "25003",
            "label": "Berkshire County",
            "stateId": "25000",
            "state": "MA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "25005",
            "label": "Bristol County",
            "stateId": "25000",
            "state": "MA"
        },
        {
            "id": "25007",
            "label": "Dukes County",
            "stateId": "25000",
            "state": "MA"
        },
        {
            "id": "25009",
            "label": "Essex County",
            "stateId": "25000",
            "state": "MA"
        },
        {
            "id": "25013",
            "label": "Hampden County",
            "stateId": "25000",
            "state": "MA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "25017",
            "label": "Middlesex County",
            "stateId": "25000",
            "state": "MA"
        },
        {
            "id": "25019",
            "label": "Nantucket County",
            "stateId": "25000",
            "state": "MA"
        },
        {
            "id": "25021",
            "label": "Norfolk County",
            "stateId": "25000",
            "state": "MA"
        },
        {
            "id": "25023",
            "label": "Plymouth County",
            "stateId": "25000",
            "state": "MA"
        },
        {
            "id": "25025",
            "label": "Suffolk County",
            "stateId": "25000",
            "state": "MA"
        },
        {
            "id": "25027",
            "label": "Worcester County",
            "stateId": "25000",
            "state": "MA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "26001",
            "label": "Alcona County",
            "stateId": "26000",
            "state": "MI"
        },
        {
            "id": "26003",
            "label": "Alger County",
            "stateId": "26000",
            "state": "MI"
        },
        {
            "id": "26005",
            "label": "Allegan County",
            "stateId": "26000",
            "state": "MI"
        },
        {
            "id": "26007",
            "label": "Alpena County",
            "stateId": "26000",
            "state": "MI"
        },
        {
            "id": "26009",
            "label": "Antrim County",
            "stateId": "26000",
            "state": "MI"
        },
        {
            "id": "26011",
            "label": "Arenac County",
            "stateId": "26000",
            "state": "MI"
        },
        {
            "id": "26013",
            "label": "Baraga County",
            "stateId": "26000",
            "state": "MI"
        },
        {
            "id": "26015",
            "label": "Barry County",
            "stateId": "26000",
            "state": "MI",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "26017",
            "label": "Bay County",
            "stateId": "26000",
            "state": "MI"
        },
        {
            "id": "26019",
            "label": "Benzie County",
            "stateId": "26000",
            "state": "MI"
        },
        {
            "id": "26021",
            "label": "Berrien County",
            "stateId": "26000",
            "state": "MI"
        },
        {
            "id": "26023",
            "label": "Branch County",
            "stateId": "26000",
            "state": "MI",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "26025",
            "label": "Calhoun County",
            "stateId": "26000",
            "state": "MI",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "26027",
            "label": "Cass County",
            "stateId": "26000",
            "state": "MI",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "26029",
            "label": "Charlevoix County",
            "stateId": "26000",
            "state": "MI"
        },
        {
            "id": "26031",
            "label": "Cheboygan County",
            "stateId": "26000",
            "state": "MI"
        },
        {
            "id": "26033",
            "label": "Chippewa County",
            "stateId": "26000",
            "state": "MI"
        },
        {
            "id": "26035",
            "label": "Clare County",
            "stateId": "26000",
            "state": "MI",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "26039",
            "label": "Crawford County",
            "stateId": "26000",
            "state": "MI",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "26041",
            "label": "Delta County",
            "stateId": "26000",
            "state": "MI"
        },
        {
            "id": "26043",
            "label": "Dickinson County",
            "stateId": "26000",
            "state": "MI",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "26045",
            "label": "Eaton County",
            "stateId": "26000",
            "state": "MI",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "26047",
            "label": "Emmet County",
            "stateId": "26000",
            "state": "MI"
        },
        {
            "id": "26053",
            "label": "Gogebic County",
            "stateId": "26000",
            "state": "MI"
        },
        {
            "id": "26055",
            "label": "Grand Traverse County",
            "stateId": "26000",
            "state": "MI"
        },
        {
            "id": "26059",
            "label": "Hillsdale County",
            "stateId": "26000",
            "state": "MI",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "26061",
            "label": "Houghton County",
            "stateId": "26000",
            "state": "MI"
        },
        {
            "id": "26063",
            "label": "Huron County",
            "stateId": "26000",
            "state": "MI"
        },
        {
            "id": "26067",
            "label": "Ionia County",
            "stateId": "26000",
            "state": "MI",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "26069",
            "label": "Iosco County",
            "stateId": "26000",
            "state": "MI"
        },
        {
            "id": "26075",
            "label": "Jackson County",
            "stateId": "26000",
            "state": "MI",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "26077",
            "label": "Kalamazoo County",
            "stateId": "26000",
            "state": "MI",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "26079",
            "label": "Kalkaska County",
            "stateId": "26000",
            "state": "MI",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "26081",
            "label": "Kent County",
            "stateId": "26000",
            "state": "MI",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "26083",
            "label": "Keweenaw County",
            "stateId": "26000",
            "state": "MI"
        },
        {
            "id": "26085",
            "label": "Lake County",
            "stateId": "26000",
            "state": "MI",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "26087",
            "label": "Lapeer County",
            "stateId": "26000",
            "state": "MI",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "26089",
            "label": "Leelanau County",
            "stateId": "26000",
            "state": "MI"
        },
        {
            "id": "26091",
            "label": "Lenawee County",
            "stateId": "26000",
            "state": "MI",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "26093",
            "label": "Livingston County",
            "stateId": "26000",
            "state": "MI",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "26095",
            "label": "Luce County",
            "stateId": "26000",
            "state": "MI"
        },
        {
            "id": "26097",
            "label": "Mackinac County",
            "stateId": "26000",
            "state": "MI"
        },
        {
            "id": "26099",
            "label": "Macomb County",
            "stateId": "26000",
            "state": "MI"
        },
        {
            "id": "26101",
            "label": "Manistee County",
            "stateId": "26000",
            "state": "MI"
        },
        {
            "id": "26103",
            "label": "Marquette County",
            "stateId": "26000",
            "state": "MI"
        },
        {
            "id": "26105",
            "label": "Mason County",
            "stateId": "26000",
            "state": "MI"
        },
        {
            "id": "26107",
            "label": "Mecosta County",
            "stateId": "26000",
            "state": "MI",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "26109",
            "label": "Menominee County",
            "stateId": "26000",
            "state": "MI"
        },
        {
            "id": "26113",
            "label": "Missaukee County",
            "stateId": "26000",
            "state": "MI",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "26115",
            "label": "Monroe County",
            "stateId": "26000",
            "state": "MI"
        },
        {
            "id": "26117",
            "label": "Montcalm County",
            "stateId": "26000",
            "state": "MI",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "26119",
            "label": "Montmorency County",
            "stateId": "26000",
            "state": "MI",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "26121",
            "label": "Muskegon County",
            "stateId": "26000",
            "state": "MI"
        },
        {
            "id": "26123",
            "label": "Newaygo County",
            "stateId": "26000",
            "state": "MI",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "26125",
            "label": "Oakland County",
            "stateId": "26000",
            "state": "MI",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "26127",
            "label": "Oceana County",
            "stateId": "26000",
            "state": "MI"
        },
        {
            "id": "26129",
            "label": "Ogemaw County",
            "stateId": "26000",
            "state": "MI",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "26131",
            "label": "Ontonagon County",
            "stateId": "26000",
            "state": "MI"
        },
        {
            "id": "26133",
            "label": "Osceola County",
            "stateId": "26000",
            "state": "MI",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "26135",
            "label": "Oscoda County",
            "stateId": "26000",
            "state": "MI",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "26137",
            "label": "Otsego County",
            "stateId": "26000",
            "state": "MI",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "26139",
            "label": "Ottawa County",
            "stateId": "26000",
            "state": "MI"
        },
        {
            "id": "26141",
            "label": "Presque Isle County",
            "stateId": "26000",
            "state": "MI"
        },
        {
            "id": "26143",
            "label": "Roscommon County",
            "stateId": "26000",
            "state": "MI",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "26145",
            "label": "Saginaw County",
            "stateId": "26000",
            "state": "MI",
            "ShorelineCounties": []
        },
        {
            "id": "26151",
            "label": "Sanilac County",
            "stateId": "26000",
            "state": "MI"
        },
        {
            "id": "26153",
            "label": "Schoolcraft County",
            "stateId": "26000",
            "state": "MI"
        },
        {
            "id": "26147",
            "label": "St. Clair County",
            "stateId": "26000",
            "state": "MI"
        },
        {
            "id": "26149",
            "label": "St. Joseph County",
            "stateId": "26000",
            "state": "MI",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "26157",
            "label": "Tuscola County",
            "stateId": "26000",
            "state": "MI"
        },
        {
            "id": "26159",
            "label": "Van Buren County",
            "stateId": "26000",
            "state": "MI"
        },
        {
            "id": "26161",
            "label": "Washtenaw County",
            "stateId": "26000",
            "state": "MI",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "26163",
            "label": "Wayne County",
            "stateId": "26000",
            "state": "MI"
        },
        {
            "id": "26165",
            "label": "Wexford County",
            "stateId": "26000",
            "state": "MI",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "27017",
            "label": "Carlton County",
            "stateId": "27000",
            "state": "MN",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "27031",
            "label": "Cook County",
            "stateId": "27000",
            "state": "MN"
        },
        {
            "id": "27075",
            "label": "Lake County",
            "stateId": "27000",
            "state": "MN"
        },
        {
            "id": "27137",
            "label": "St. Louis County",
            "stateId": "27000",
            "state": "MN"
        },
        {
            "id": "28005",
            "label": "Amite County",
            "stateId": "28000",
            "state": "MS",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "28039",
            "label": "George County",
            "stateId": "28000",
            "state": "MS",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "28045",
            "label": "Hancock County",
            "stateId": "28000",
            "state": "MS"
        },
        {
            "id": "28047",
            "label": "Harrison County",
            "stateId": "28000",
            "state": "MS"
        },
        {
            "id": "28059",
            "label": "Jackson County",
            "stateId": "28000",
            "state": "MS"
        },
        {
            "id": "28073",
            "label": "Lamar County",
            "stateId": "28000",
            "state": "MS",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "28091",
            "label": "Marion County",
            "stateId": "28000",
            "state": "MS",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "28109",
            "label": "Pearl River County",
            "stateId": "28000",
            "state": "MS",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "28113",
            "label": "Pike County",
            "stateId": "28000",
            "state": "MS",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "28131",
            "label": "Stone County",
            "stateId": "28000",
            "state": "MS",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "28147",
            "label": "Walthall County",
            "stateId": "28000",
            "state": "MS",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "28157",
            "label": "Wilkinson County",
            "stateId": "28000",
            "state": "MS",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "33001",
            "label": "Belknap County",
            "stateId": "33000",
            "state": "NH",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "33003",
            "label": "Carroll County",
            "stateId": "33000",
            "state": "NH",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "33011",
            "label": "Hillsborough County",
            "stateId": "33000",
            "state": "NH",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "33013",
            "label": "Merrimack County",
            "stateId": "33000",
            "state": "NH",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "33015",
            "label": "Rockingham County",
            "stateId": "33000",
            "state": "NH"
        },
        {
            "id": "33017",
            "label": "Strafford County",
            "stateId": "33000",
            "state": "NH"
        },
        {
            "id": "34001",
            "label": "Atlantic County",
            "stateId": "34000",
            "state": "NJ"
        },
        {
            "id": "34003",
            "label": "Bergen County",
            "stateId": "34000",
            "state": "NJ"
        },
        {
            "id": "34005",
            "label": "Burlington County",
            "stateId": "34000",
            "state": "NJ"
        },
        {
            "id": "34007",
            "label": "Camden County",
            "stateId": "34000",
            "state": "NJ"
        },
        {
            "id": "34009",
            "label": "Cape May County",
            "stateId": "34000",
            "state": "NJ"
        },
        {
            "id": "34011",
            "label": "Cumberland County",
            "stateId": "34000",
            "state": "NJ"
        },
        {
            "id": "34013",
            "label": "Essex County",
            "stateId": "34000",
            "state": "NJ"
        },
        {
            "id": "34015",
            "label": "Gloucester County",
            "stateId": "34000",
            "state": "NJ"
        },
        {
            "id": "34017",
            "label": "Hudson County",
            "stateId": "34000",
            "state": "NJ"
        },
        {
            "id": "34019",
            "label": "Hunterdon County",
            "stateId": "34000",
            "state": "NJ",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "34021",
            "label": "Mercer County",
            "stateId": "34000",
            "state": "NJ",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "34023",
            "label": "Middlesex County",
            "stateId": "34000",
            "state": "NJ"
        },
        {
            "id": "34025",
            "label": "Monmouth County",
            "stateId": "34000",
            "state": "NJ"
        },
        {
            "id": "34027",
            "label": "Morris County",
            "stateId": "34000",
            "state": "NJ",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "34029",
            "label": "Ocean County",
            "stateId": "34000",
            "state": "NJ"
        },
        {
            "id": "34031",
            "label": "Passaic County",
            "stateId": "34000",
            "state": "NJ",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "34033",
            "label": "Salem County",
            "stateId": "34000",
            "state": "NJ"
        },
        {
            "id": "34035",
            "label": "Somerset County",
            "stateId": "34000",
            "state": "NJ"
        },
        {
            "id": "34037",
            "label": "Sussex County",
            "stateId": "34000",
            "state": "NJ",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "34039",
            "label": "Union County",
            "stateId": "34000",
            "state": "NJ"
        },
        {
            "id": "36001",
            "label": "Albany County",
            "stateId": "36000",
            "state": "NY",
            "ShorelineCounties": []
        },
        {
            "id": "36005",
            "label": "Bronx County",
            "stateId": "36000",
            "state": "NY"
        },
        {
            "id": "36009",
            "label": "Cattaraugus County",
            "stateId": "36000",
            "state": "NY",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "36011",
            "label": "Cayuga County",
            "stateId": "36000",
            "state": "NY"
        },
        {
            "id": "36013",
            "label": "Chautauqua County",
            "stateId": "36000",
            "state": "NY"
        },
        {
            "id": "36019",
            "label": "Clinton County",
            "stateId": "36000",
            "state": "NY",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "36021",
            "label": "Columbia County",
            "stateId": "36000",
            "state": "NY",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "36027",
            "label": "Dutchess County",
            "stateId": "36000",
            "state": "NY"
        },
        {
            "id": "36029",
            "label": "Erie County",
            "stateId": "36000",
            "state": "NY"
        },
        {
            "id": "36033",
            "label": "Franklin County",
            "stateId": "36000",
            "state": "NY",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "36037",
            "label": "Genesee County",
            "stateId": "36000",
            "state": "NY",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "36039",
            "label": "Greene County",
            "stateId": "36000",
            "state": "NY",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "36041",
            "label": "Hamilton County",
            "stateId": "36000",
            "state": "NY",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "36043",
            "label": "Herkimer County",
            "stateId": "36000",
            "state": "NY",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "36045",
            "label": "Jefferson County",
            "stateId": "36000",
            "state": "NY"
        },
        {
            "id": "36047",
            "label": "Kings County",
            "stateId": "36000",
            "state": "NY"
        },
        {
            "id": "36049",
            "label": "Lewis County",
            "stateId": "36000",
            "state": "NY",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "36051",
            "label": "Livingston County",
            "stateId": "36000",
            "state": "NY",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "36055",
            "label": "Monroe County",
            "stateId": "36000",
            "state": "NY"
        },
        {
            "id": "36059",
            "label": "Nassau County",
            "stateId": "36000",
            "state": "NY"
        },
        {
            "id": "36061",
            "label": "New York County",
            "stateId": "36000",
            "state": "NY"
        },
        {
            "id": "36063",
            "label": "Niagara County",
            "stateId": "36000",
            "state": "NY"
        },
        {
            "id": "36067",
            "label": "Onondaga County",
            "stateId": "36000",
            "state": "NY",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "36069",
            "label": "Ontario County",
            "stateId": "36000",
            "state": "NY",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "36071",
            "label": "Orange County",
            "stateId": "36000",
            "state": "NY"
        },
        {
            "id": "36073",
            "label": "Orleans County",
            "stateId": "36000",
            "state": "NY"
        },
        {
            "id": "36075",
            "label": "Oswego County",
            "stateId": "36000",
            "state": "NY"
        },
        {
            "id": "36079",
            "label": "Putnam County",
            "stateId": "36000",
            "state": "NY"
        },
        {
            "id": "36081",
            "label": "Queens County",
            "stateId": "36000",
            "state": "NY"
        },
        {
            "id": "36083",
            "label": "Rensselaer County",
            "stateId": "36000",
            "state": "NY",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "36085",
            "label": "Richmond County",
            "stateId": "36000",
            "state": "NY"
        },
        {
            "id": "36087",
            "label": "Rockland County",
            "stateId": "36000",
            "state": "NY"
        },
        {
            "id": "36093",
            "label": "Schenectady County",
            "stateId": "36000",
            "state": "NY",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "36089",
            "label": "St. Lawrence County",
            "stateId": "36000",
            "state": "NY",
            "ShorelineCounties": []
        },
        {
            "id": "36103",
            "label": "Suffolk County",
            "stateId": "36000",
            "state": "NY"
        },
        {
            "id": "36111",
            "label": "Ulster County",
            "stateId": "36000",
            "state": "NY"
        },
        {
            "id": "36117",
            "label": "Wayne County",
            "stateId": "36000",
            "state": "NY"
        },
        {
            "id": "36119",
            "label": "Westchester County",
            "stateId": "36000",
            "state": "NY"
        },
        {
            "id": "36121",
            "label": "Wyoming County",
            "stateId": "36000",
            "state": "NY",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "37007",
            "label": "Anson County",
            "stateId": "37000",
            "state": "NC",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "37013",
            "label": "Beaufort County",
            "stateId": "37000",
            "state": "NC"
        },
        {
            "id": "37015",
            "label": "Bertie County",
            "stateId": "37000",
            "state": "NC"
        },
        {
            "id": "37017",
            "label": "Bladen County",
            "stateId": "37000",
            "state": "NC",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "37019",
            "label": "Brunswick County",
            "stateId": "37000",
            "state": "NC"
        },
        {
            "id": "37029",
            "label": "Camden County",
            "stateId": "37000",
            "state": "NC"
        },
        {
            "id": "37031",
            "label": "Carteret County",
            "stateId": "37000",
            "state": "NC"
        },
        {
            "id": "37041",
            "label": "Chowan County",
            "stateId": "37000",
            "state": "NC"
        },
        {
            "id": "37047",
            "label": "Columbus County",
            "stateId": "37000",
            "state": "NC",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "37049",
            "label": "Craven County",
            "stateId": "37000",
            "state": "NC"
        },
        {
            "id": "37051",
            "label": "Cumberland County",
            "stateId": "37000",
            "state": "NC",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "37053",
            "label": "Currituck County",
            "stateId": "37000",
            "state": "NC"
        },
        {
            "id": "37055",
            "label": "Dare County",
            "stateId": "37000",
            "state": "NC"
        },
        {
            "id": "37061",
            "label": "Duplin County",
            "stateId": "37000",
            "state": "NC",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "37065",
            "label": "Edgecombe County",
            "stateId": "37000",
            "state": "NC",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "37073",
            "label": "Gates County",
            "stateId": "37000",
            "state": "NC"
        },
        {
            "id": "37079",
            "label": "Greene County",
            "stateId": "37000",
            "state": "NC",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "37083",
            "label": "Halifax County",
            "stateId": "37000",
            "state": "NC",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "37091",
            "label": "Hertford County",
            "stateId": "37000",
            "state": "NC"
        },
        {
            "id": "37095",
            "label": "Hyde County",
            "stateId": "37000",
            "state": "NC"
        },
        {
            "id": "37103",
            "label": "Jones County",
            "stateId": "37000",
            "state": "NC",
            "ENOW": []
        },
        {
            "id": "37107",
            "label": "Lenoir County",
            "stateId": "37000",
            "state": "NC",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "37117",
            "label": "Martin County",
            "stateId": "37000",
            "state": "NC",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "37129",
            "label": "New Hanover County",
            "stateId": "37000",
            "state": "NC"
        },
        {
            "id": "37131",
            "label": "Northampton County",
            "stateId": "37000",
            "state": "NC",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "37133",
            "label": "Onslow County",
            "stateId": "37000",
            "state": "NC"
        },
        {
            "id": "37137",
            "label": "Pamlico County",
            "stateId": "37000",
            "state": "NC"
        },
        {
            "id": "37139",
            "label": "Pasquotank County",
            "stateId": "37000",
            "state": "NC"
        },
        {
            "id": "37141",
            "label": "Pender County",
            "stateId": "37000",
            "state": "NC"
        },
        {
            "id": "37143",
            "label": "Perquimans County",
            "stateId": "37000",
            "state": "NC"
        },
        {
            "id": "37147",
            "label": "Pitt County",
            "stateId": "37000",
            "state": "NC",
            "ENOW": []
        },
        {
            "id": "37153",
            "label": "Richmond County",
            "stateId": "37000",
            "state": "NC",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "37163",
            "label": "Sampson County",
            "stateId": "37000",
            "state": "NC",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "37165",
            "label": "Scotland County",
            "stateId": "37000",
            "state": "NC",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "37177",
            "label": "Tyrrell County",
            "stateId": "37000",
            "state": "NC"
        },
        {
            "id": "37187",
            "label": "Washington County",
            "stateId": "37000",
            "state": "NC"
        },
        {
            "id": "37191",
            "label": "Wayne County",
            "stateId": "37000",
            "state": "NC",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "37195",
            "label": "Wilson County",
            "stateId": "37000",
            "state": "NC",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "39005",
            "label": "Ashland County",
            "stateId": "39000",
            "state": "OH",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "39007",
            "label": "Ashtabula County",
            "stateId": "39000",
            "state": "OH"
        },
        {
            "id": "39033",
            "label": "Crawford County",
            "stateId": "39000",
            "state": "OH",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "39035",
            "label": "Cuyahoga County",
            "stateId": "39000",
            "state": "OH"
        },
        {
            "id": "39039",
            "label": "Defiance County",
            "stateId": "39000",
            "state": "OH",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "39043",
            "label": "Erie County",
            "stateId": "39000",
            "state": "OH"
        },
        {
            "id": "39051",
            "label": "Fulton County",
            "stateId": "39000",
            "state": "OH",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "39055",
            "label": "Geauga County",
            "stateId": "39000",
            "state": "OH",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "39063",
            "label": "Hancock County",
            "stateId": "39000",
            "state": "OH",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "39069",
            "label": "Henry County",
            "stateId": "39000",
            "state": "OH",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "39077",
            "label": "Huron County",
            "stateId": "39000",
            "state": "OH",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "39085",
            "label": "Lake County",
            "stateId": "39000",
            "state": "OH"
        },
        {
            "id": "39093",
            "label": "Lorain County",
            "stateId": "39000",
            "state": "OH"
        },
        {
            "id": "39095",
            "label": "Lucas County",
            "stateId": "39000",
            "state": "OH"
        },
        {
            "id": "39101",
            "label": "Marion County",
            "stateId": "39000",
            "state": "OH",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "39103",
            "label": "Medina County",
            "stateId": "39000",
            "state": "OH",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "39123",
            "label": "Ottawa County",
            "stateId": "39000",
            "state": "OH"
        },
        {
            "id": "39133",
            "label": "Portage County",
            "stateId": "39000",
            "state": "OH",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "39143",
            "label": "Sandusky County",
            "stateId": "39000",
            "state": "OH"
        },
        {
            "id": "39147",
            "label": "Seneca County",
            "stateId": "39000",
            "state": "OH",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "39153",
            "label": "Summit County",
            "stateId": "39000",
            "state": "OH",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "39155",
            "label": "Trumbull County",
            "stateId": "39000",
            "state": "OH",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "39173",
            "label": "Wood County",
            "stateId": "39000",
            "state": "OH",
            "ShorelineCounties": []
        },
        {
            "id": "39175",
            "label": "Wyandot County",
            "stateId": "39000",
            "state": "OH",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "41003",
            "label": "Benton County",
            "stateId": "41000",
            "state": "OR",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "41005",
            "label": "Clackamas County",
            "stateId": "41000",
            "state": "OR",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "41007",
            "label": "Clatsop County",
            "stateId": "41000",
            "state": "OR"
        },
        {
            "id": "41009",
            "label": "Columbia County",
            "stateId": "41000",
            "state": "OR",
            "ShorelineCounties": []
        },
        {
            "id": "41011",
            "label": "Coos County",
            "stateId": "41000",
            "state": "OR"
        },
        {
            "id": "41015",
            "label": "Curry County",
            "stateId": "41000",
            "state": "OR"
        },
        {
            "id": "41019",
            "label": "Douglas County",
            "stateId": "41000",
            "state": "OR"
        },
        {
            "id": "41033",
            "label": "Josephine County",
            "stateId": "41000",
            "state": "OR",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "41039",
            "label": "Lane County",
            "stateId": "41000",
            "state": "OR"
        },
        {
            "id": "41041",
            "label": "Lincoln County",
            "stateId": "41000",
            "state": "OR"
        },
        {
            "id": "41051",
            "label": "Multnomah County",
            "stateId": "41000",
            "state": "OR",
            "ShorelineCounties": []
        },
        {
            "id": "41057",
            "label": "Tillamook County",
            "stateId": "41000",
            "state": "OR"
        },
        {
            "id": "42001",
            "label": "Adams County",
            "stateId": "42000",
            "state": "PA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "42011",
            "label": "Berks County",
            "stateId": "42000",
            "state": "PA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "42017",
            "label": "Bucks County",
            "stateId": "42000",
            "state": "PA",
            "ShorelineCounties": []
        },
        {
            "id": "42029",
            "label": "Chester County",
            "stateId": "42000",
            "state": "PA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "42045",
            "label": "Delaware County",
            "stateId": "42000",
            "state": "PA"
        },
        {
            "id": "42049",
            "label": "Erie County",
            "stateId": "42000",
            "state": "PA"
        },
        {
            "id": "42071",
            "label": "Lancaster County",
            "stateId": "42000",
            "state": "PA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "42075",
            "label": "Lebanon County",
            "stateId": "42000",
            "state": "PA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "42077",
            "label": "Lehigh County",
            "stateId": "42000",
            "state": "PA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "42091",
            "label": "Montgomery County",
            "stateId": "42000",
            "state": "PA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "42101",
            "label": "Philadelphia County",
            "stateId": "42000",
            "state": "PA"
        },
        {
            "id": "42107",
            "label": "Schuylkill County",
            "stateId": "42000",
            "state": "PA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "42133",
            "label": "York County",
            "stateId": "42000",
            "state": "PA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "44001",
            "label": "Bristol County",
            "stateId": "44000",
            "state": "RI"
        },
        {
            "id": "44003",
            "label": "Kent County",
            "stateId": "44000",
            "state": "RI"
        },
        {
            "id": "44005",
            "label": "Newport County",
            "stateId": "44000",
            "state": "RI"
        },
        {
            "id": "44007",
            "label": "Providence County",
            "stateId": "44000",
            "state": "RI"
        },
        {
            "id": "44009",
            "label": "Washington County",
            "stateId": "44000",
            "state": "RI"
        },
        {
            "id": "45005",
            "label": "Allendale County",
            "stateId": "45000",
            "state": "SC",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "45013",
            "label": "Beaufort County",
            "stateId": "45000",
            "state": "SC"
        },
        {
            "id": "45015",
            "label": "Berkeley County",
            "stateId": "45000",
            "state": "SC"
        },
        {
            "id": "45019",
            "label": "Charleston County",
            "stateId": "45000",
            "state": "SC"
        },
        {
            "id": "45025",
            "label": "Chesterfield County",
            "stateId": "45000",
            "state": "SC",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "45027",
            "label": "Clarendon County",
            "stateId": "45000",
            "state": "SC",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "45029",
            "label": "Colleton County",
            "stateId": "45000",
            "state": "SC"
        },
        {
            "id": "45031",
            "label": "Darlington County",
            "stateId": "45000",
            "state": "SC",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "45033",
            "label": "Dillon County",
            "stateId": "45000",
            "state": "SC",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "45035",
            "label": "Dorchester County",
            "stateId": "45000",
            "state": "SC"
        },
        {
            "id": "45041",
            "label": "Florence County",
            "stateId": "45000",
            "state": "SC",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "45043",
            "label": "Georgetown County",
            "stateId": "45000",
            "state": "SC"
        },
        {
            "id": "45049",
            "label": "Hampton County",
            "stateId": "45000",
            "state": "SC",
            "ENOW": []
        },
        {
            "id": "45051",
            "label": "Horry County",
            "stateId": "45000",
            "state": "SC"
        },
        {
            "id": "45053",
            "label": "Jasper County",
            "stateId": "45000",
            "state": "SC"
        },
        {
            "id": "45055",
            "label": "Kershaw County",
            "stateId": "45000",
            "state": "SC",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "45057",
            "label": "Lancaster County",
            "stateId": "45000",
            "state": "SC",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "45061",
            "label": "Lee County",
            "stateId": "45000",
            "state": "SC",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "45067",
            "label": "Marion County",
            "stateId": "45000",
            "state": "SC",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "45069",
            "label": "Marlboro County",
            "stateId": "45000",
            "state": "SC",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "45085",
            "label": "Sumter County",
            "stateId": "45000",
            "state": "SC",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "45089",
            "label": "Williamsburg County",
            "stateId": "45000",
            "state": "SC",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "48007",
            "label": "Aransas County",
            "stateId": "48000",
            "state": "TX"
        },
        {
            "id": "48015",
            "label": "Austin County",
            "stateId": "48000",
            "state": "TX",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "48025",
            "label": "Bee County",
            "stateId": "48000",
            "state": "TX",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "48039",
            "label": "Brazoria County",
            "stateId": "48000",
            "state": "TX"
        },
        {
            "id": "48047",
            "label": "Brooks County",
            "stateId": "48000",
            "state": "TX",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "48057",
            "label": "Calhoun County",
            "stateId": "48000",
            "state": "TX"
        },
        {
            "id": "48061",
            "label": "Cameron County",
            "stateId": "48000",
            "state": "TX"
        },
        {
            "id": "48071",
            "label": "Chambers County",
            "stateId": "48000",
            "state": "TX"
        },
        {
            "id": "48089",
            "label": "Colorado County",
            "stateId": "48000",
            "state": "TX",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "48123",
            "label": "DeWitt County",
            "stateId": "48000",
            "state": "TX",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "48131",
            "label": "Duval County",
            "stateId": "48000",
            "state": "TX",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "48149",
            "label": "Fayette County",
            "stateId": "48000",
            "state": "TX",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "48157",
            "label": "Fort Bend County",
            "stateId": "48000",
            "state": "TX",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "48167",
            "label": "Galveston County",
            "stateId": "48000",
            "state": "TX"
        },
        {
            "id": "48175",
            "label": "Goliad County",
            "stateId": "48000",
            "state": "TX",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "48201",
            "label": "Harris County",
            "stateId": "48000",
            "state": "TX"
        },
        {
            "id": "48215",
            "label": "Hidalgo County",
            "stateId": "48000",
            "state": "TX",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "48239",
            "label": "Jackson County",
            "stateId": "48000",
            "state": "TX"
        },
        {
            "id": "48241",
            "label": "Jasper County",
            "stateId": "48000",
            "state": "TX",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "48245",
            "label": "Jefferson County",
            "stateId": "48000",
            "state": "TX"
        },
        {
            "id": "48247",
            "label": "Jim Hogg County",
            "stateId": "48000",
            "state": "TX",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "48249",
            "label": "Jim Wells County",
            "stateId": "48000",
            "state": "TX",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "48261",
            "label": "Kenedy County",
            "stateId": "48000",
            "state": "TX"
        },
        {
            "id": "48273",
            "label": "Kleberg County",
            "stateId": "48000",
            "state": "TX"
        },
        {
            "id": "48285",
            "label": "Lavaca County",
            "stateId": "48000",
            "state": "TX",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "48291",
            "label": "Liberty County",
            "stateId": "48000",
            "state": "TX",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "48297",
            "label": "Live Oak County",
            "stateId": "48000",
            "state": "TX",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "48321",
            "label": "Matagorda County",
            "stateId": "48000",
            "state": "TX"
        },
        {
            "id": "48351",
            "label": "Newton County",
            "stateId": "48000",
            "state": "TX",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "48355",
            "label": "Nueces County",
            "stateId": "48000",
            "state": "TX"
        },
        {
            "id": "48361",
            "label": "Orange County",
            "stateId": "48000",
            "state": "TX"
        },
        {
            "id": "48391",
            "label": "Refugio County",
            "stateId": "48000",
            "state": "TX"
        },
        {
            "id": "48409",
            "label": "San Patricio County",
            "stateId": "48000",
            "state": "TX"
        },
        {
            "id": "48427",
            "label": "Starr County",
            "stateId": "48000",
            "state": "TX",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "48457",
            "label": "Tyler County",
            "stateId": "48000",
            "state": "TX",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "48469",
            "label": "Victoria County",
            "stateId": "48000",
            "state": "TX"
        },
        {
            "id": "48473",
            "label": "Waller County",
            "stateId": "48000",
            "state": "TX",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "48477",
            "label": "Washington County",
            "stateId": "48000",
            "state": "TX",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "48479",
            "label": "Webb County",
            "stateId": "48000",
            "state": "TX",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "48481",
            "label": "Wharton County",
            "stateId": "48000",
            "state": "TX",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "48489",
            "label": "Willacy County",
            "stateId": "48000",
            "state": "TX"
        },
        {
            "id": "51001",
            "label": "Accomack County",
            "stateId": "51000",
            "state": "VA"
        },
        {
            "id": "51510",
            "label": "Alexandria City",
            "stateId": "51000",
            "state": "VA"
        },
        {
            "id": "51007",
            "label": "Amelia County",
            "stateId": "51000",
            "state": "VA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "51011",
            "label": "Appomattox County",
            "stateId": "51000",
            "state": "VA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "51013",
            "label": "Arlington County",
            "stateId": "51000",
            "state": "VA"
        },
        {
            "id": "51029",
            "label": "Buckingham County",
            "stateId": "51000",
            "state": "VA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "51033",
            "label": "Caroline County",
            "stateId": "51000",
            "state": "VA"
        },
        {
            "id": "51036",
            "label": "Charles City County",
            "stateId": "51000",
            "state": "VA"
        },
        {
            "id": "51550",
            "label": "Chesapeake City",
            "stateId": "51000",
            "state": "VA"
        },
        {
            "id": "51041",
            "label": "Chesterfield County",
            "stateId": "51000",
            "state": "VA"
        },
        {
            "id": "51570",
            "label": "Colonial Heights City",
            "stateId": "51000",
            "state": "VA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "51049",
            "label": "Cumberland County",
            "stateId": "51000",
            "state": "VA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "51053",
            "label": "Dinwiddie County",
            "stateId": "51000",
            "state": "VA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "51057",
            "label": "Essex County",
            "stateId": "51000",
            "state": "VA"
        },
        {
            "id": "51600",
            "label": "Fairfax City",
            "stateId": "51000",
            "state": "VA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "51059",
            "label": "Fairfax County",
            "stateId": "51000",
            "state": "VA"
        },
        {
            "id": "51610",
            "label": "Falls Church City",
            "stateId": "51000",
            "state": "VA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "51061",
            "label": "Fauquier County",
            "stateId": "51000",
            "state": "VA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "51065",
            "label": "Fluvanna County",
            "stateId": "51000",
            "state": "VA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "51630",
            "label": "Fredericksburg City",
            "stateId": "51000",
            "state": "VA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "51073",
            "label": "Gloucester County",
            "stateId": "51000",
            "state": "VA"
        },
        {
            "id": "51075",
            "label": "Goochland County",
            "stateId": "51000",
            "state": "VA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "51650",
            "label": "Hampton City",
            "stateId": "51000",
            "state": "VA"
        },
        {
            "id": "51085",
            "label": "Hanover County",
            "stateId": "51000",
            "state": "VA"
        },
        {
            "id": "51087",
            "label": "Henrico County",
            "stateId": "51000",
            "state": "VA"
        },
        {
            "id": "51670",
            "label": "Hopewell City",
            "stateId": "51000",
            "state": "VA"
        },
        {
            "id": "51093",
            "label": "Isle of Wight County",
            "stateId": "51000",
            "state": "VA"
        },
        {
            "id": "51095",
            "label": "James City County",
            "stateId": "51000",
            "state": "VA"
        },
        {
            "id": "51097",
            "label": "King and Queen County",
            "stateId": "51000",
            "state": "VA"
        },
        {
            "id": "51099",
            "label": "King George County",
            "stateId": "51000",
            "state": "VA"
        },
        {
            "id": "51101",
            "label": "King William County",
            "stateId": "51000",
            "state": "VA"
        },
        {
            "id": "51103",
            "label": "Lancaster County",
            "stateId": "51000",
            "state": "VA"
        },
        {
            "id": "51109",
            "label": "Louisa County",
            "stateId": "51000",
            "state": "VA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "51683",
            "label": "Manassas City",
            "stateId": "51000",
            "state": "VA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "51685",
            "label": "Manassas Park City",
            "stateId": "51000",
            "state": "VA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "51115",
            "label": "Mathews County",
            "stateId": "51000",
            "state": "VA"
        },
        {
            "id": "51119",
            "label": "Middlesex County",
            "stateId": "51000",
            "state": "VA"
        },
        {
            "id": "51127",
            "label": "New Kent County",
            "stateId": "51000",
            "state": "VA"
        },
        {
            "id": "51700",
            "label": "Newport News City",
            "stateId": "51000",
            "state": "VA"
        },
        {
            "id": "51710",
            "label": "Norfolk City",
            "stateId": "51000",
            "state": "VA"
        },
        {
            "id": "51131",
            "label": "Northampton County",
            "stateId": "51000",
            "state": "VA"
        },
        {
            "id": "51133",
            "label": "Northumberland County",
            "stateId": "51000",
            "state": "VA"
        },
        {
            "id": "51135",
            "label": "Nottoway County",
            "stateId": "51000",
            "state": "VA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "51137",
            "label": "Orange County",
            "stateId": "51000",
            "state": "VA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "51730",
            "label": "Petersburg City",
            "stateId": "51000",
            "state": "VA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "51735",
            "label": "Poquoson City",
            "stateId": "51000",
            "state": "VA"
        },
        {
            "id": "51740",
            "label": "Portsmouth City",
            "stateId": "51000",
            "state": "VA"
        },
        {
            "id": "51145",
            "label": "Powhatan County",
            "stateId": "51000",
            "state": "VA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "51147",
            "label": "Prince Edward County",
            "stateId": "51000",
            "state": "VA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "51149",
            "label": "Prince George County",
            "stateId": "51000",
            "state": "VA"
        },
        {
            "id": "51153",
            "label": "Prince William County",
            "stateId": "51000",
            "state": "VA"
        },
        {
            "id": "51760",
            "label": "Richmond City",
            "stateId": "51000",
            "state": "VA",
            "ShorelineCounties": []
        },
        {
            "id": "51159",
            "label": "Richmond County",
            "stateId": "51000",
            "state": "VA"
        },
        {
            "id": "51177",
            "label": "Spotsylvania County",
            "stateId": "51000",
            "state": "VA"
        },
        {
            "id": "51179",
            "label": "Stafford County",
            "stateId": "51000",
            "state": "VA"
        },
        {
            "id": "51800",
            "label": "Suffolk City",
            "stateId": "51000",
            "state": "VA"
        },
        {
            "id": "51181",
            "label": "Surry County",
            "stateId": "51000",
            "state": "VA"
        },
        {
            "id": "51810",
            "label": "Virginia Beach City",
            "stateId": "51000",
            "state": "VA"
        },
        {
            "id": "51193",
            "label": "Westmoreland County",
            "stateId": "51000",
            "state": "VA"
        },
        {
            "id": "51830",
            "label": "Williamsburg City",
            "stateId": "51000",
            "state": "VA"
        },
        {
            "id": "51199",
            "label": "York County",
            "stateId": "51000",
            "state": "VA"
        },
        {
            "id": "53009",
            "label": "Clallam County",
            "stateId": "53000",
            "state": "WA"
        },
        {
            "id": "53011",
            "label": "Clark County",
            "stateId": "53000",
            "state": "WA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "53015",
            "label": "Cowlitz County",
            "stateId": "53000",
            "state": "WA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "53027",
            "label": "Grays Harbor County",
            "stateId": "53000",
            "state": "WA"
        },
        {
            "id": "53029",
            "label": "Island County",
            "stateId": "53000",
            "state": "WA"
        },
        {
            "id": "53031",
            "label": "Jefferson County",
            "stateId": "53000",
            "state": "WA"
        },
        {
            "id": "53033",
            "label": "King County",
            "stateId": "53000",
            "state": "WA"
        },
        {
            "id": "53035",
            "label": "Kitsap County",
            "stateId": "53000",
            "state": "WA"
        },
        {
            "id": "53041",
            "label": "Lewis County",
            "stateId": "53000",
            "state": "WA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "53045",
            "label": "Mason County",
            "stateId": "53000",
            "state": "WA"
        },
        {
            "id": "53049",
            "label": "Pacific County",
            "stateId": "53000",
            "state": "WA"
        },
        {
            "id": "53053",
            "label": "Pierce County",
            "stateId": "53000",
            "state": "WA"
        },
        {
            "id": "53055",
            "label": "San Juan County",
            "stateId": "53000",
            "state": "WA"
        },
        {
            "id": "53057",
            "label": "Skagit County",
            "stateId": "53000",
            "state": "WA"
        },
        {
            "id": "53059",
            "label": "Skamania County",
            "stateId": "53000",
            "state": "WA",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "53061",
            "label": "Snohomish County",
            "stateId": "53000",
            "state": "WA"
        },
        {
            "id": "53067",
            "label": "Thurston County",
            "stateId": "53000",
            "state": "WA"
        },
        {
            "id": "53069",
            "label": "Wahkiakum County",
            "stateId": "53000",
            "state": "WA"
        },
        {
            "id": "53073",
            "label": "Whatcom County",
            "stateId": "53000",
            "state": "WA"
        },
        {
            "id": "55003",
            "label": "Ashland County",
            "stateId": "55000",
            "state": "WI"
        },
        {
            "id": "55007",
            "label": "Bayfield County",
            "stateId": "55000",
            "state": "WI"
        },
        {
            "id": "55009",
            "label": "Brown County",
            "stateId": "55000",
            "state": "WI"
        },
        {
            "id": "55015",
            "label": "Calumet County",
            "stateId": "55000",
            "state": "WI",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "55029",
            "label": "Door County",
            "stateId": "55000",
            "state": "WI"
        },
        {
            "id": "55031",
            "label": "Douglas County",
            "stateId": "55000",
            "state": "WI"
        },
        {
            "id": "55037",
            "label": "Florence County",
            "stateId": "55000",
            "state": "WI",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "55039",
            "label": "Fond du Lac County",
            "stateId": "55000",
            "state": "WI",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "55041",
            "label": "Forest County",
            "stateId": "55000",
            "state": "WI",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "55051",
            "label": "Iron County",
            "stateId": "55000",
            "state": "WI"
        },
        {
            "id": "55059",
            "label": "Kenosha County",
            "stateId": "55000",
            "state": "WI"
        },
        {
            "id": "55061",
            "label": "Kewaunee County",
            "stateId": "55000",
            "state": "WI"
        },
        {
            "id": "55071",
            "label": "Manitowoc County",
            "stateId": "55000",
            "state": "WI"
        },
        {
            "id": "55075",
            "label": "Marinette County",
            "stateId": "55000",
            "state": "WI"
        },
        {
            "id": "55078",
            "label": "Menominee County",
            "stateId": "55000",
            "state": "WI",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "55079",
            "label": "Milwaukee County",
            "stateId": "55000",
            "state": "WI"
        },
        {
            "id": "55083",
            "label": "Oconto County",
            "stateId": "55000",
            "state": "WI"
        },
        {
            "id": "55087",
            "label": "Outagamie County",
            "stateId": "55000",
            "state": "WI",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "55089",
            "label": "Ozaukee County",
            "stateId": "55000",
            "state": "WI"
        },
        {
            "id": "55101",
            "label": "Racine County",
            "stateId": "55000",
            "state": "WI"
        },
        {
            "id": "55115",
            "label": "Shawano County",
            "stateId": "55000",
            "state": "WI",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "55117",
            "label": "Sheboygan County",
            "stateId": "55000",
            "state": "WI"
        },
        {
            "id": "55131",
            "label": "Washington County",
            "stateId": "55000",
            "state": "WI",
            "ENOW": [],
            "ShorelineCounties": []
        },
        {
            "id": "60010",
            "label": "Eastern District",
            "stateId": "60000",
            "state": "AS",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "60020",
            "label": "Manua District",
            "stateId": "60000",
            "state": "AS",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "60030",
            "label": "Rose Island",
            "stateId": "60000",
            "state": "AS",
            "ENOW": ["oceanEconomy", "selfEmployment"],
            "ShorelineCounties": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "60040",
            "label": "Swains Island",
            "stateId": "60000",
            "state": "AS",
            "ENOW": ["oceanEconomy", "selfEmployment"],
            "ShorelineCounties": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "60050",
            "label": "Western District",
            "stateId": "60000",
            "state": "AS",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "66010",
            "label": "Guam",
            "stateId": "66000",
            "state": "GU",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "69085",
            "label": "Northern Islands",
            "stateId": "69000",
            "state": "MP",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "69100",
            "label": "Rota",
            "stateId": "69000",
            "state": "MP",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "69110",
            "label": "Saipan",
            "stateId": "69000",
            "state": "MP",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "69120",
            "label": "Tinian",
            "stateId": "69000",
            "state": "MP",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72001",
            "label": "Adjuntas Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"],
            "ShorelineCounties": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72003",
            "label": "Aguada Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72005",
            "label": "Aguadilla Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72007",
            "label": "Aguas Buenas Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"],
            "ShorelineCounties": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72009",
            "label": "Aibonito Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"],
            "ShorelineCounties": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72011",
            "label": "Añasco Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72013",
            "label": "Arecibo Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72015",
            "label": "Arroyo Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72017",
            "label": "Barceloneta Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72019",
            "label": "Barranquitas Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"],
            "ShorelineCounties": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72021",
            "label": "Bayamón Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72023",
            "label": "Cabo Rojo Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72025",
            "label": "Caguas Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"],
            "ShorelineCounties": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72027",
            "label": "Camuy Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72029",
            "label": "Canóvanas Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"],
            "ShorelineCounties": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72031",
            "label": "Carolina Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72033",
            "label": "Cataño Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72035",
            "label": "Cayey Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"],
            "ShorelineCounties": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72037",
            "label": "Ceiba Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72039",
            "label": "Ciales Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"],
            "ShorelineCounties": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72041",
            "label": "Cidra Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"],
            "ShorelineCounties": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72043",
            "label": "Coamo Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"],
            "ShorelineCounties": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72045",
            "label": "Comerío Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"],
            "ShorelineCounties": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72047",
            "label": "Corozal Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"],
            "ShorelineCounties": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72049",
            "label": "Culebra Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72051",
            "label": "Dorado Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72053",
            "label": "Fajardo Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72054",
            "label": "Florida Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"],
            "ShorelineCounties": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72055",
            "label": "Guánica Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72057",
            "label": "Guayama Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72059",
            "label": "Guayanilla Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72061",
            "label": "Guaynabo Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72063",
            "label": "Gurabo Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"],
            "ShorelineCounties": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72065",
            "label": "Hatillo Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72067",
            "label": "Hormigueros Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"],
            "ShorelineCounties": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72069",
            "label": "Humacao Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72071",
            "label": "Isabela Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72073",
            "label": "Jayuya Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"],
            "ShorelineCounties": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72075",
            "label": "Juana Díaz Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72077",
            "label": "Juncos Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"],
            "ShorelineCounties": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72079",
            "label": "Lajas Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72081",
            "label": "Lares Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"],
            "ShorelineCounties": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72083",
            "label": "Las Marías Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"],
            "ShorelineCounties": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72085",
            "label": "Las Piedras Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"],
            "ShorelineCounties": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72087",
            "label": "Loíza Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72089",
            "label": "Luquillo Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72091",
            "label": "Manatí Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72093",
            "label": "Maricao Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"],
            "ShorelineCounties": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72095",
            "label": "Maunabo Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72097",
            "label": "Mayagüez Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72099",
            "label": "Moca Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"],
            "ShorelineCounties": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72101",
            "label": "Morovis Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"],
            "ShorelineCounties": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72103",
            "label": "Naguabo Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72105",
            "label": "Naranjito Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"],
            "ShorelineCounties": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72107",
            "label": "Orocovis Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"],
            "ShorelineCounties": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72109",
            "label": "Patillas Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72111",
            "label": "Peñuelas Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72113",
            "label": "Ponce Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72115",
            "label": "Quebradillas Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72117",
            "label": "Rincón Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72119",
            "label": "Río Grande Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72121",
            "label": "Sabana Grande Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"],
            "ShorelineCounties": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72123",
            "label": "Salinas Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72125",
            "label": "San Germán Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"],
            "ShorelineCounties": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72127",
            "label": "San Juan Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72129",
            "label": "San Lorenzo Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"],
            "ShorelineCounties": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72131",
            "label": "San Sebastián Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"],
            "ShorelineCounties": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72133",
            "label": "Santa Isabel Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72135",
            "label": "Toa Alta Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"],
            "ShorelineCounties": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72137",
            "label": "Toa Baja Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72139",
            "label": "Trujillo Alto Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"],
            "ShorelineCounties": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72141",
            "label": "Utuado Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"],
            "ShorelineCounties": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72143",
            "label": "Vega Alta Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72145",
            "label": "Vega Baja Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72147",
            "label": "Vieques Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72149",
            "label": "Villalba Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"],
            "ShorelineCounties": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72151",
            "label": "Yabucoa Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72153",
            "label": "Yauco Municipio",
            "stateId": "72000",
            "state": "PR",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "78010",
            "label": "St. Croix",
            "stateId": "78000",
            "state": "VI",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "78020",
            "label": "St. John",
            "stateId": "78000",
            "state": "VI",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "78030",
            "label": "St. Thomas",
            "stateId": "78000",
            "state": "VI",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        }
    ]
}